import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col, InputGroup, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaPlus, FaEdit, FaTrash, FaSortUp, FaSortDown, FaSort, FaSearch } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import * as api from '~/Services/Service';
import ModalCategoriaDepartamento from './ModalCategoriaDepartamento';

const CategoriaDepartamento = () => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [categoriaEditando, setCategoriaEditando] = useState(null);
  const [confirmacao, setConfirmacao] = useState({ show: false, item: null });
  const [filtro, setFiltro] = useState('');
  const [ordenacao, setOrdenacao] = useState({ campo: 'codigo', direcao: 'asc' });

  // Modal departamentos vinculados
  const [showDeptosModal, setShowDeptosModal] = useState(false);
  const [deptosCategoria, setDeptosCategoria] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  const [loadingDeptos, setLoadingDeptos] = useState(false);
  const [filtroDeptos, setFiltroDeptos] = useState('');

  useEffect(() => {
    carregarCategorias();
  }, []);

  const carregarCategorias = async () => {
    setLoading(true);
    try {
      const resp = await api.buscarCategoriasDepartamento();
      setCategorias(resp || []);
    } catch (e) {
      toast.error('Erro ao carregar categorias de departamento.');
    } finally {
      setLoading(false);
    }
  };

  const handleOrdenacao = (campo) => {
    setOrdenacao((prev) => {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  const iconeOrdenacao = (campo) => {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  const thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  const linkStyle = {
    cursor: 'pointer',
    color: '#0747a6',
    textDecoration: 'underline',
    fontWeight: 'bold',
  };

  const handleNova = () => {
    setCategoriaEditando(null);
    setShowModal(true);
  };

  const handleEditar = (item) => {
    setCategoriaEditando(item);
    setShowModal(true);
  };

  const handleExcluir = (item) => {
    setConfirmacao({ show: true, item: item });
  };

  const handleConfirmarExclusao = async (confirmado) => {
    if (!confirmado) {
      setConfirmacao({ show: false, item: null });
      return;
    }
    const item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await api.excluirCategoriaDepartamento({ codigo: item.codigo });
      toast.success('Categoria excluída com sucesso.');
      carregarCategorias();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao excluir categoria.');
    }
  };

  const handleSalvar = () => {
    setShowModal(false);
    carregarCategorias();
  };

  const handleAbrirDepartamentos = async (cat) => {
    setDeptosCategoria(cat);
    setDepartamentos([]);
    setFiltroDeptos('');
    setShowDeptosModal(true);
    setLoadingDeptos(true);
    try {
      const resp = await api.buscarDepartamentos();
      const filtrados = (resp || []).filter((d) => { return d.grupo === cat.codigo; });
      setDepartamentos(filtrados);
    } catch (e) {
      toast.error('Erro ao carregar departamentos.');
    } finally {
      setLoadingDeptos(false);
    }
  };

  const categoriasFiltradas = categorias.filter((item) => {
    if (!filtro) return true;
    const termo = filtro.toLowerCase();
    return (
      String(item.codigo).indexOf(termo) >= 0 ||
      (item.descricao || '').toLowerCase().indexOf(termo) >= 0 ||
      String(item.faixa_ini).indexOf(termo) >= 0 ||
      String(item.faixa_fim).indexOf(termo) >= 0
    );
  });

  const categoriasOrdenadas = categoriasFiltradas.slice().sort((a, b) => {
    const campo = ordenacao.campo;
    const dir = ordenacao.direcao === 'asc' ? 1 : -1;
    let valA = a[campo];
    let valB = b[campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    if (typeof valA === 'string') {
      return dir * valA.toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (valA - valB);
  });

  const itemExclusao = confirmacao.item;

  if (loading) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .catdepto-desktop { display: block; }\
        .catdepto-mobile  { display: none; }\
        @media (max-width: 768px) {\
          .catdepto-desktop { display: none !important; }\
          .catdepto-mobile  { display: block; }\
          .catdepto-filtro-row { flex-direction: column; }\
          .catdepto-filtro-row .text-right { text-align: right !important; margin-top: 8px; }\
        }\
      '}</style>

      <Header title="Categorias de Departamento" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center catdepto-filtro-row">
            <Col md={4}>
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text><FaSearch /></InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  placeholder="Filtrar por código, descrição ou faixa..."
                  value={filtro}
                  onChange={(e) => { setFiltro(e.target.value); }}
                />
              </InputGroup>
            </Col>
            <Col className="text-right">
              <Button size="sm" variant="primary" onClick={handleNova}>
                <FaPlus className="mr-1" /> Nova Categoria
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm" style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Categorias de Departamento
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({categoriasOrdenadas.length} {categoriasOrdenadas.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {categoriasOrdenadas.length === 0 ? (
            <p className="text-muted text-center my-4">Nenhuma categoria cadastrada.</p>
          ) : (
            <>
              {/* Desktop */}
              <div className="catdepto-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th
                        style={Object.assign({ width: '100px' }, thSortStyle)}
                        onClick={() => { handleOrdenacao('codigo'); }}
                      >
                        Código{iconeOrdenacao('codigo')}
                      </th>
                      <th
                        style={thSortStyle}
                        onClick={() => { handleOrdenacao('descricao'); }}
                      >
                        Descrição{iconeOrdenacao('descricao')}
                      </th>
                      <th
                        style={Object.assign({ width: '130px' }, thSortStyle)}
                        onClick={() => { handleOrdenacao('faixa_ini'); }}
                      >
                        Faixa Inicial{iconeOrdenacao('faixa_ini')}
                      </th>
                      <th
                        style={Object.assign({ width: '130px' }, thSortStyle)}
                        onClick={() => { handleOrdenacao('faixa_fim'); }}
                      >
                        Faixa Final{iconeOrdenacao('faixa_fim')}
                      </th>
                      <th
                        style={Object.assign({ width: '130px', textAlign: 'center' }, thSortStyle)}
                        onClick={() => { handleOrdenacao('qtd_departamentos'); }}
                      >
                        Departamentos{iconeOrdenacao('qtd_departamentos')}
                      </th>
                      <th style={{ width: '90px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoriasOrdenadas.map((item) => {
                      return (
                        <tr key={item.codigo}>
                          <td>{item.codigo}</td>
                          <td>{item.descricao}</td>
                          <td>{item.faixa_ini}</td>
                          <td>{item.faixa_fim}</td>
                          <td className="text-center">
                            {(item.qtd_departamentos || 0) > 0 ? (
                              <span style={linkStyle} onClick={() => { handleAbrirDepartamentos(item); }}>
                                {item.qtd_departamentos}
                              </span>
                            ) : (
                              <span style={{ color: '#6c757d' }}>0</span>
                            )}
                          </td>
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              title="Editar"
                              className="mr-1"
                              onClick={() => { handleEditar(item); }}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Excluir"
                              onClick={() => { handleExcluir(item); }}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="catdepto-mobile p-2">
                {categoriasOrdenadas.map((item) => {
                  return (
                    <Card key={item.codigo} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>{item.descricao}</strong>
                            <br />
                            <small className="text-muted">Código: {item.codigo}</small>
                          </div>
                        </div>
                        <div style={{ fontSize: '0.85rem' }} className="mb-1">
                          Faixa: <strong>{item.faixa_ini}</strong> — <strong>{item.faixa_fim}</strong>
                        </div>
                        <div style={{ fontSize: '0.85rem' }} className="mb-2">
                          Departamentos:{' '}
                          {(item.qtd_departamentos || 0) > 0 ? (
                            <span style={linkStyle} onClick={() => { handleAbrirDepartamentos(item); }}>
                              {item.qtd_departamentos}
                            </span>
                          ) : (
                            <strong>0</strong>
                          )}
                        </div>
                        <div className="d-flex justify-content-end">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="mr-1"
                            onClick={() => { handleEditar(item); }}
                          >
                            <FaEdit className="mr-1" /> Editar
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => { handleExcluir(item); }}
                          >
                            <FaTrash className="mr-1" /> Excluir
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      <ModalConfirmacao
        show={confirmacao.show}
        title="Confirmar Exclusão"
        message={
          itemExclusao
            ? 'Deseja excluir a categoria "' + (itemExclusao.descricao || '') + '" (Código ' + itemExclusao.codigo + ')?'
            : ''
        }
        onClose={handleConfirmarExclusao}
      />

      <ModalCategoriaDepartamento
        show={showModal}
        onHide={() => { setShowModal(false); }}
        categoria={categoriaEditando}
        categorias={categorias}
        onSalvar={handleSalvar}
      />

      {/* Modal: Departamentos vinculados à categoria */}
      {showDeptosModal && (
        <Modal show onHide={() => { setShowDeptosModal(false); }} centered size="lg">
          <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
            <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
              Departamentos — {deptosCategoria ? deptosCategoria.descricao : ''}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingDeptos ? (
              <p className="text-center text-muted my-3">Carregando...</p>
            ) : departamentos.length === 0 ? (
              <p className="text-center text-muted my-3">Nenhum departamento vinculado a esta categoria.</p>
            ) : (
              <>
                <InputGroup size="sm" className="mb-2">
                  <InputGroup.Prepend>
                    <InputGroup.Text><FaSearch /></InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    placeholder="Filtrar por código, descrição ou responsável..."
                    value={filtroDeptos}
                    onChange={(e) => { setFiltroDeptos(e.target.value); }}
                  />
                </InputGroup>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  <Table striped bordered hover size="sm" className="mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: '80px' }}>Código</th>
                        <th>Descrição</th>
                        <th>Responsável</th>
                        <th style={{ width: '80px', textAlign: 'center' }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {departamentos.filter((d) => {
                        if (!filtroDeptos) return true;
                        var termo = filtroDeptos.toLowerCase();
                        return (
                          String(d.codigo).indexOf(termo) >= 0 ||
                          (d.descricao || '').toLowerCase().indexOf(termo) >= 0 ||
                          (d.nome_responsavel || '').toLowerCase().indexOf(termo) >= 0
                        );
                      }).map((d) => {
                        return (
                          <tr key={d.codigo}>
                            <td>{d.codigo}</td>
                            <td>{d.descricao}</td>
                            <td>{d.nome_responsavel || '—'}</td>
                            <td className="text-center">
                              <span style={{
                                color: d.status === 'A' ? '#28a745' : '#dc3545',
                                fontWeight: 'bold',
                                fontSize: '0.85rem',
                              }}>
                                {d.status === 'A' ? 'Ativo' : 'Inativo'}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
            <div className="text-muted text-right mt-1" style={{ fontSize: '0.8rem' }}>
              {departamentos.length} departamento{departamentos.length !== 1 ? 's' : ''}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" size="sm" onClick={() => { setShowDeptosModal(false); }}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};

export default CategoriaDepartamento;
